<template>
  <loading-element v-if="authStore.isLoading"></loading-element>
  <div class="main bg-primary dashboard-main" v-else>
    <div class="rowSpaceBetween fullWidth mb-8">
      <div class="dashboard-heading">
        <h1 class="dashboard-title">
          Bonjour <span class="dashboard-title__pseudo">{{ authStore.userInfos?.username || '' }},</span>
        </h1>
        <p class="dashboard-subtitle">Qu'est-ce qu'on mange aujourd'hui ?</p>
      </div>
      <div class="rowCustom">
        <ThemeToggle />
        <AccountToggle />
      </div>
    </div>
    <Home_block></Home_block>
  </div>
</template>

<script>
import { onMounted } from "vue";
import Home_block from "./HomeDisplayBlock.vue";
import LoadingElement from "../Animations/LoadingElement.vue";
import { useAuthStore } from "@/store/auth_store";
import ThemeToggle from "@/components/Utils/ThemeToggle.vue";
import AccountToggle from "@/components/Utils/AccountToggle.vue";

export default {
  name: "HelloWorld",
  components: {
    LoadingElement,
    Home_block,
    ThemeToggle,
    AccountToggle,
  },
  setup() {
    const authStore = useAuthStore();

    onMounted(() => {
      // authStore.initAuth() est déjà appelé dans App.vue donc pas besoin ici
    });

    return {
      authStore,
    };
  },
};
</script>

<style scoped>
.row {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
}

.spaceBetween {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.dataTable {
  border-radius: 2em;
  background-color: #242c36;
}

.accentTextLight {
  color: #f3a530;
}

.containerTab {
  display: inline-block;
  padding: 0.5em 1em 0.5em 1em;
  margin-left: 2em;
  border-top-left-radius: 1.5em;
  border-top-right-radius: 1.5em;
  background-color: #242c36;
}

.tabContainer {
  margin-bottom: 2em;
}

.rowContainer {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
}

.productAlertTitle {
  font-family: "Public Sans", sans-serif;
  font-size: 1.5em;
  color: #ffffff;
}

.roundedDialog {
  border-radius: 2em !important;
  padding: 1em;
}

.rowCustom {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.dashboard-main {
  background: #F9F7F8 !important;
  min-height: 100vh;
}

.dashboard-title {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 400;
  font-family: "Open Runde", "Montserrat", sans-serif;
  color: #1A1615;
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.dashboard-title__pseudo {
  font-weight: 700;
  color: #1A1615;
}

.dashboard-heading {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.dashboard-subtitle {
  margin: 0;
  font-size: clamp(11px, 1vw, 13px);
  font-weight: 400;
  color: #1A1615;
  opacity: 0.45;
  font-family: "Open Runde", "Montserrat", sans-serif;
}
</style>
